import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, c2, r1, r2, r3, r4, gbw) {
  var gain = 1 + r4 / r3;
  var sqrtTerm = Math.sqrt(r1 * r2 * c1 * c2);
  var fpPrime = 1 / (2 * Math.PI * sqrtTerm);
  var d1 = r1 * c2;
  var d2 = r2 * c2;
  var d3 = r1 * c1;
  var qPrime = sqrtTerm / (d1 + d2 + d3 * (1 - gain));
  var gbwMod = Math.sqrt(1 + (gain * gain) / (2 * Math.PI * r2 * c2 * gbw));

  var q = qPrime * gbwMod;
  var fp = fpPrime / gbwMod;

  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var r1 = circuit.r1.value;
  var r2 = circuit.r2.value;
  var r3 = circuit.r3.value;
  var r4 = circuit.r4.value;
  var c1 = circuit.c1.value;
  var c2 = circuit.c2.value;
  var gbw = circuit.opAmp.gbw;
  return this.computeFromComponentValues(c1, c2, r1, r2, r3, r4, gbw);
}
